/* ============================================================
   Terrah B2B — JS partagé
   - Calendly popup helper (déclenché via data-terrah-calendly="popup")
   ============================================================ */
(function(){
  var CALENDLY_URL = 'https://calendly.com/dan-terrah/30min?primary_color=c34621&hide_gdpr_banner=1';

  function openCalendlyPopup(e){
    if(e) e.preventDefault();
    if(window.Calendly && typeof window.Calendly.initPopupWidget === 'function'){
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    } else {
      window.open('https://calendly.com/dan-terrah/30min', '_blank', 'noopener');
    }
    return false;
  }

  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-terrah-calendly="popup"]');
    if(trigger){ openCalendlyPopup(e); }
  }, false);

  window.openCalendly = openCalendlyPopup;
})();
